import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-display-table-column',
  imports: [
    FormsModule,
    TranslatePipe
],
  templateUrl: './display-table-column.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-table-column.component.scss'
})
export class DisplayTableColumnComponent implements OnInit {

  @Input() data!: {[key: string]: boolean};

  columns: string[][] = [
    [],
    [],
    [],
    []
  ];

  ngOnInit(): void {
    const length = Object.keys(this.data).length;
    let elemPerColumn = Math.floor(length/4);
    if (length%4 !== 0) {
      ++elemPerColumn;
    }

    let column = 0;
    for (const index in this.data) {
      this.columns[column].push(index);

      if (this.columns[column].length === elemPerColumn) {
        ++column;
      }
    }
  }
}
